import React from "react";
import { Box, Button, Link } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { getChatbotInteractiveLabels, getChatbotLinkButtons } from "../../../utils/chatbotQuickReplies";

/**
 * Botões e links interativos do chatbot (estilo simulador / WhatsApp).
 */
export default function TeamChatbotInteractive({
  metadata,
  disabled = false,
  onSelect,
  maxWidth = "min(72%, 520px)",
}) {
  if (!metadata || typeof metadata !== "object") return null;

  const buttons = getChatbotInteractiveLabels(metadata);
  const linkButtons = getChatbotLinkButtons(metadata);

  const ctaUrl =
    metadata.interactiveOptions && typeof metadata.interactiveOptions === "object"
      ? String(metadata.interactiveOptions.ctaUrl || metadata.interactiveOptions.url || "").trim()
      : "";
  const ctaLabel =
    metadata.interactiveOptions && typeof metadata.interactiveOptions === "object"
      ? String(
          metadata.interactiveOptions.ctaDisplayText ||
            metadata.interactiveOptions.ctaLabel ||
            metadata.interactiveOptions.label ||
            metadata.interactiveOptions.title ||
            "Abrir link"
        ).trim()
      : "Abrir link";

  const hasLegacyCta = Boolean(ctaUrl) && !linkButtons.some((item) => item.url === ctaUrl);

  if (!buttons.length && !linkButtons.length && !hasLegacyCta) return null;

  return (
    <Box
      sx={{
        width: maxWidth,
        maxWidth: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 0.5,
        mt: 0.5,
      }}
    >
      {buttons.map((label, idx) => (
        <Button
          key={`${idx}-${label}`}
          variant="outlined"
          size="small"
          disabled={disabled}
          onClick={() => onSelect?.(label)}
          sx={{
            textTransform: "none",
            justifyContent: "center",
            borderRadius: 2,
            bgcolor: "background.paper",
            fontWeight: 500,
          }}
        >
          {label}
        </Button>
      ))}

      {linkButtons.map((linkBtn, idx) => (
        <Button
          key={`link-${idx}-${linkBtn.url}`}
          component={Link}
          href={linkBtn.url}
          target="_blank"
          rel="noopener noreferrer"
          variant="outlined"
          size="small"
          endIcon={<OpenInNewIcon sx={{ fontSize: 14 }} />}
          sx={{
            textTransform: "none",
            justifyContent: "center",
            borderRadius: 2,
            bgcolor: "background.paper",
            fontWeight: 500,
          }}
        >
          {linkBtn.label || "Abrir link"}
        </Button>
      ))}

      {hasLegacyCta ? (
        <Button
          component={Link}
          href={ctaUrl}
          target="_blank"
          rel="noopener noreferrer"
          variant="outlined"
          size="small"
          endIcon={<OpenInNewIcon sx={{ fontSize: 14 }} />}
          sx={{
            textTransform: "none",
            justifyContent: "center",
            borderRadius: 2,
            bgcolor: "background.paper",
            fontWeight: 500,
          }}
        >
          {ctaLabel}
        </Button>
      ) : null}
    </Box>
  );
}
